var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%","width":"100%"}},[_c('iframe',{staticStyle:{"border":"0"},attrs:{"width":"100%","height":"100%","Loading":"lazy","allowfullscreen":"","src":_vm.googleMapDirection}})])
}
var staticRenderFns = []

export { render, staticRenderFns }